// extracted by mini-css-extract-plugin
export default {"table":"s_t","table_lobby":"s_u","table_isScale":"s_v","table_isTwoTables":"s_w","table_mtb":"s_x","table__frame":"s_y","table__frame_isActive":"s_z","table_isMobile":"s_A"};